var map = {
	"./alb.ts": [
		"a2c6",
		"chunk-2d2080da"
	],
	"./am.ts": [
		"3544",
		"chunk-2d0b9d58"
	],
	"./ar-IQ.ts": [
		"80c2",
		"chunk-2d0dd61d"
	],
	"./az-AZ.ts": [
		"8704",
		"chunk-2d0dea39"
	],
	"./bm.ts": [
		"ca41",
		"chunk-2d221451"
	],
	"./bn-BD.ts": [
		"67a5",
		"chunk-2d0d076b"
	],
	"./da.ts": [
		"a2e9",
		"chunk-2d20811b"
	],
	"./de.ts": [
		"4e3e",
		"chunk-2d0cc5f9"
	],
	"./en-US.ts": [
		"6ca7",
		"chunk-2d0dac99"
	],
	"./es.ts": [
		"bd64",
		"chunk-2d21ab76"
	],
	"./fa.ts": [
		"b9bf",
		"chunk-2d210f91"
	],
	"./fi.ts": [
		"928d",
		"chunk-2d0e4cfb"
	],
	"./fr.ts": [
		"23bc",
		"chunk-2d0b2738"
	],
	"./id.ts": [
		"709f",
		"chunk-2d0d5cdc"
	],
	"./india.ts": [
		"d706",
		"chunk-2d21ea8f"
	],
	"./it-IT.ts": [
		"c8c0",
		"chunk-2d218018"
	],
	"./it.ts": [
		"f4d7",
		"chunk-2d22ce57"
	],
	"./ja.ts": [
		"ad84",
		"chunk-2d213755"
	],
	"./kk.ts": [
		"105b",
		"chunk-2d0aa222"
	],
	"./kr.ts": [
		"0e38",
		"chunk-2d0af450"
	],
	"./kur.ts": [
		"b5d0",
		"chunk-2d210095"
	],
	"./lo.ts": [
		"ff14",
		"chunk-2d2383d9"
	],
	"./mn.ts": [
		"c9de",
		"chunk-2d21842d"
	],
	"./my.ts": [
		"81c5",
		"chunk-2d0dd9e1"
	],
	"./nl-NL.ts": [
		"70da",
		"chunk-2d0d620c"
	],
	"./pl.ts": [
		"5f01",
		"chunk-2d0d3d88"
	],
	"./ps.ts": [
		"8382",
		"chunk-2d0ddc2b"
	],
	"./pt-br.ts": [
		"a701",
		"chunk-2d208d6d"
	],
	"./ru.ts": [
		"ead3",
		"chunk-2d2302e1"
	],
	"./si-LK.ts": [
		"bfe3",
		"chunk-2d21b8a8"
	],
	"./sw.ts": [
		"7846",
		"chunk-2d0d7a19"
	],
	"./th.ts": [
		"bb7c",
		"chunk-2d21a442"
	],
	"./tr-TR.ts": [
		"c226",
		"chunk-2d2163a9"
	],
	"./uk.ts": [
		"ce92",
		"chunk-2d2223f1"
	],
	"./uz.ts": [
		"e341",
		"chunk-2d225061"
	],
	"./vi.ts": [
		"57f0",
		"chunk-2d0c93a2"
	],
	"./zh-CN.ts": [
		"c447",
		"chunk-2d216b6a"
	],
	"./zh-HK.ts": [
		"5508",
		"chunk-2d0c859e"
	],
	"./zh-TW.ts": [
		"85e0",
		"chunk-2d0de91e"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9ff6";
module.exports = webpackAsyncContext;